import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "../../utils/classNames";

export function DropzoneTitle({
  className,
  ...props
}: ComponentPropsWithoutRef<"p">) {
  return (
    <p
      {...props}
      className={classNames(
        "text-sm/5 select-none text-center font-medium",
        className,
      )}
    />
  );
}
